"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountGradeRoutes = void 0;
exports.accountGradeRoutes = [
    {
        name: 'accountGrade.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'accountGrade.sort',
        path: ['/sort'],
        method: 'POST'
    },
    {
        name: 'accountGrade.create',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'accountGrade.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'accountGrade.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'accountGrade.delete',
        path: '/:id',
        method: 'DELETE'
    }
];
